function stampedInit (){
   console.log('Stamped ADA init');
  
  function keyToClick(event) {
    if (event.key == "Enter") {
      event.preventDefault();
      event.target.click();
    }
  }
  
 
  const allStampedBadge = document.querySelectorAll('.stamped-badge');
  const allStampedQas = document.querySelectorAll('.stampedQAs');
  const allLegends = document.querySelectorAll('legend');
  const allListRoles = document.querySelectorAll('[role="list"]');
  const allButtonRoles = document.querySelectorAll('[role="button"]');
  const allLinkButtons = document.querySelectorAll('a[role="button"]');
  const allReviewHeaderTitles = document.querySelectorAll('.stamped-review-header-title');

  allStampedBadge.forEach((badge) => {
    badge.addEventListener("keydown", (event) => {
      keyToClick(event)
    })
  })

  allStampedQas.forEach((qas) => {
    qas.addEventListener("keydown", (event) => {
      keyToClick(event)
    })
  })

  allLegends.forEach((legend) => {
    if (legend.style.display === 'none') {
      legend.style.display = 'block';
      legend.classList.add('sr-only');
    }
  })

  allButtonRoles.forEach((button) => {
    const ariaLabel = button.getAttribute("aria-label");
    const innerText = button.innerText;
    if (ariaLabel !== innerText && ariaLabel !== null && ariaLabel !== 'undefined' && innerText.length > 2) {
      button.removeAttribute("aria-label");
    }
  })

  allLinkButtons.forEach((link) => {
    link.href = "#";
  })

 allReviewHeaderTitles.forEach((title) => {
    if (title.innerText === '' || title.innerText === undefined || title.innerText === null) {
        title.innerText = 'No Title';
    }
  })
  
}

setTimeout(stampedInit(), 200)